import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LigneFinancementProduitService } from '../../core/service/ligne-financement/ligne-financement-produit.service';
import { LigneFinancementProduit } from '../../core/model/ligneFinancement/ligneFinancementProduit';
import { AddLigneFinancementProduitComponent } from './add-ligne-financement-produit/add-ligne-financement-produit.component';
import { EditLigneFinancementProduitComponent } from './editigne-financement-produit/editigne-financement-produit.component';

@Component({
  selector: "app-ligne-financement-produit",
  templateUrl: "./ligne-financement-produit.component.html",
  styleUrls: ["./ligne-financement-produit.component.scss"]
})
export class LigneFinancementProduitComponent implements OnInit {
  ligneFinancement: LigneFinancementProduit[];

  constructor(
    private modalService: NgbModal,
    private _ligneFinancementService: LigneFinancementProduitService
  ) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._ligneFinancementService.getAllLigneFinancementProduit().subscribe(
      data => {
        this.ligneFinancement = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  edit(ligneFinancement: LigneFinancementProduit): void {
    const modalRef = this.modalService.open(
      EditLigneFinancementProduitComponent,
      {
        centered: true
      }
    );
    modalRef.componentInstance.ligneFinancement = ligneFinancement;

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(
      AddLigneFinancementProduitComponent,
      {
        centered: true
      }
    );

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }
}
